var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlacktype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 4361.52 978.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{font-size:486.35px;fill:#2b1b2c;font-family:StretchProRegular, Stretch Pro;}.cls-3{letter-spacing:-0.06em;}.cls-4{letter-spacing:0em;}.cls-5{letter-spacing:-0.03em;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 46.06,
    y1: 217.54,
    x2: 1015.47,
    y2: 777.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f2b600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#f4570a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#f26c7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#f17ace"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f080ed"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M997.65,112.53,613.34,363,602.63,152.81C600.84,117.65,563.37,96,532,112.11l-356,239.6L44.2,275.58A27.38,27.38,0,0,0,3.14,299.29V469.65l-.26.22L.58,796.21c-5.72,88.48,32,102.1,63.29,86L448.18,631.75,458.89,842c1.79,35.17,39.27,56.77,70.6,40.71l356-239.61,131.85,76.13a27.37,27.37,0,0,0,41.06-23.71V525.13l.27-.23,2.29-326.34C1066.67,110.08,1029,96.47,997.65,112.53Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1247.35 838) scale(0.92 1)"
  }, "FLUEN", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 2357.31,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 2875.28,
    y: 0
  }, "Y")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1233.49 413.16) scale(0.92 1)"
  }, "CH", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 1086.5,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 1603.98,
    y: 0
  }, "SE"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlacktype);
export default __webpack_public_path__ + "static/media/logo_blacktype.ef105ac49cbcfb96308008e77b8e194e.svg";
export { ForwardRef as ReactComponent };